import { ITag, NeutralColors, mergeStyleSets, normalize } from '@fluentui/react';
import {
  Radio,
  RadioGroup,
  FluentProvider,
  webLightTheme,
  Button,
} from '@fluentui/react-components';
import React from 'react';
import { MessagingColors } from '../../../../app/common/styles/CommonStyleObjects';

interface IAgmTrackerAgingCounts {
  agingId: string;
  agingName: string;
  alternativeName: string;
  count: number;
}

interface IAgmTrackerAgingMetricSelectorProps {
  onchange: (items: ITag[], key: string, title: string) => void;
  agingSelectedItems: ITag[];
  agingItems: IAgmTrackerAgingCounts[];
  colorMapping: (count: number) => string;
}

const AgmTrackerAgingMetricSelector = (props: IAgmTrackerAgingMetricSelectorProps) => {
  const { onchange, agingSelectedItems, agingItems, colorMapping } = props;

  const styles = mergeStyleSets({
    itemContent: [
      normalize,
      {
        height: 40,
        borderBottom: `1px solid ${NeutralColors.gray30}`,
        overflow: 'hidden',
      },
    ],
    itemNameAndCount: {
      display: 'flex',
      alignItems: 'center',
    },
  });

  return (
    <FluentProvider theme={webLightTheme}>
      <RadioGroup
        aria-labelledby="agm-aging-label"
        value={agingSelectedItems?.[0]?.key?.toString() ?? undefined}
        onChange={(ev, data) => {
          const selectedItem = agingItems.find((item) => item.agingId === data.value);
          if (selectedItem) {
            onchange(
              [{ key: selectedItem.agingId, name: selectedItem.agingName }],
              'aging',
              'Agm Tracker Aging',
            );
          }
        }}
      >
        {agingItems?.map((statuses: IAgmTrackerAgingCounts) => (
          <div
            data-is-focusable
            className={styles.itemContent}
            key={statuses.agingId}
            style={{ width: '100%' }}
          >
            <div
              style={{
                borderRight: `solid 3px ${
                  colorMapping ? colorMapping(statuses?.count) : MessagingColors.defaultIcon
                }`,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: 'auto',
              }}
            >
              <Radio value={statuses.agingId} label={statuses.alternativeName} />
              <div style={{ padding: 5 }}>{statuses?.count}</div>
            </div>
          </div>
        ))}
      </RadioGroup>
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          padding: '16px 0',
        }}
      >
        <Button onClick={() => onchange([], 'aging', '')}>Reset Aging Selection</Button>
      </div>
    </FluentProvider>
  );
};

export default AgmTrackerAgingMetricSelector;
